import { ReactNode } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogActions,
    Button,
    DialogContent,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

type ConfirmDialogProps = {
    open: boolean;
    title?: string;
    content?: ReactNode;
    onConfirm?: () => void;
    onCancel?: () => void;
};

/**
 * ConfirmDialog: A simple 'title', 'text', 'yes', 'no'. For use with useConfirmDialog hook (see /src/lib/hooks.js)
 */
export default function ConfirmDialog({
    open,
    title,
    content,
    onConfirm,
    onCancel,
}: ConfirmDialogProps): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Dialog open={open} onClose={onCancel}>
            {title && <DialogTitle>{title}</DialogTitle>}
            {content && <DialogContent>{content}</DialogContent>}
            <DialogActions>
                <Button onClick={onCancel} color="inherit">
                    {t('Reject')}
                </Button>
                <Button onClick={onConfirm} color="primary" autoFocus>
                    {t('Accept')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
